import { cn } from "@/lib/utils";

interface TitleProps {
  children: React.ReactNode;
  className?: string;
  level?: 1 | 2 | 3 | 4;
}

export default function Title({ children, className, level = 3 }: TitleProps) {
  const size = {
    1: "text-4xl",
    2: "text-3xl",
    3: "text-2xl",
    4: "text-1xl",
  };

  const margin = {
    1: "mb-4 mt-4",
    2: "mb-3 mt-3",
    3: "mb-2 mt-2",
    4: "mb-1 mt-1",
  };

  const weight = {
    1: "font-bold",
    2: "font-semibold",
    3: "font-medium",
    4: "font-bold",
  };

  return (
    <h4
      className={cn(
        "tracking-tight",
        size[level],
        margin[level],
        weight[level],
        className,
      )}
    >
      {children}
    </h4>
  );
}
